import React, { useEffect, useState } from "react";
import "../exercise1/Exercise1Intro.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";
import IconBubble from "../components/IconBubble/IconBubble";

import Star2 from "../components/icons/star2.svg";
import { API_BASE_URL } from "../config";

const Exercise2Intro = () => {
  const [selectedDuration, setSelectedDuration] = useState(1); // Default to 1 minute
  const navigate = useNavigate();
  const [canStart, setCanStart] = useState(false);
  const [sunnyHTML, setSunnyHTML] = useState(
    `<span style="color: #4B5161; font-family: 'Nunito', sans-serif;">
    Practice rhythmic breathing while reading single words on-screen.
  </span>`
  );
  const [bubbleHeight, setBubbleHeight] = useState(100);
  const durations = [5, 10]; // List of durations
  const [userData, setUserData] = useState(null); // We added this

  // We added this
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });

        const data = await response.json();
        setUserData(data);

        // ✅ Automatically select the next available duration
        if (data.numExercisesUnlocked >= 1) {
          const nextUnlocked = durations.find(duration => duration >= data.currNumLevelsUnlocked);
          if (nextUnlocked) {
            setSelectedDuration(nextUnlocked);
          }
        }

      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  // We added this
  const isLevelUnlocked = (levelNumber) => {
    if (!userData) return false; // Assume locked if user data isn't loaded
    return userData.exercisesUnlocked[1] >= levelNumber;
  };

  const handleDurationClick = (duration) => {
    setSelectedDuration(duration);
  };

  const handleStartClick = () => {
    navigate("/exercise2workout", {
      state: {
        duration: selectedDuration, // Convert minutes to seconds
      },
    });
  };

  const handleVideoClick = () => {
    navigate("/exercise2video");
  };

  let handleNextNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif;">
      Repeat the exercise until you can: <br><br>

      1. <b>maintain rhythmic breathing</b> 95% of the time <br>
      2. <b>capture the words</b> 95% of the time <br>
      3. <b>comprehend the words</b> 95% of the time <br><br>

      If you succeed in these 3 things, advance to the next exercise!
    </span>`
    );
    setBubbleHeight(270);
    setCanStart(true);
  };

  let handleNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif;">
      Breathing rhythmically will enable you to grasp word meanings visually.
    </span>`
    );
  };

  const renderButton = () => {
    if (canStart) {
      return (
        <button
          className="guidance-and-start-button"
          onClick={handleStartClick}
        >
          Start
        </button>
      );
    } else {
      return (
        <button
          className="guidance-and-start-button"
          onClick={
            sunnyHTML.includes("Practice")
              ? handleNextClick
              : handleNextNextClick
          }
        >
          Next
        </button>
      );
    }
  };

  return (
    <div className="exercise1-intro-container">
      <div className="intro-content">
        <h3>Choose Duration (minutes):</h3>
        <div className="duration-selection">
          <div className="durations">
            {durations.map((duration, index) => (
              <button
                key={duration}
                className={`duration-button ${
                  selectedDuration === duration ? "selected" : ""
                }`}
                onClick={() => handleDurationClick(duration)}
                disabled={!isLevelUnlocked(index + 1)}
                style={{
                  backgroundColor: isLevelUnlocked(index + 1) ? "#4CAF50" : "#CCCCCC",
                  cursor: isLevelUnlocked(index + 1) ? "pointer" : "not-allowed"
                }}
              >
                {duration}
              </button>
              // <button
              //   key={duration}
              //   className={`duration-button ${
              //     selectedDuration === duration ? "selected" : ""
              //   }`}
              //   onClick={() => handleDurationClick(duration)}
              // >
              //   {duration}
              // </button>
            ))}
          </div>
        </div>
        <p className="hint">Hint: Complete levels to unlock more</p>
      </div>

      <div className="sunny-intro">
        <img src={Star2} alt="sunny" className="sunny" />
        <IconBubble
          width={600}
          height={bubbleHeight}
          HTML={sunnyHTML}
          color="FFFFFF"
          fontSize={25}
        />
      </div>

      <div className="bottom-buttons">
        <div></div>
        {/* <button
            className="guidance-and-start-button"
            onClick={handleVideoClick}
          >
            Guidance Video
          </button> */}
        {renderButton()}
      </div>
    </div>
  );
};

export default Exercise2Intro;
